import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CreateNotificationViewModel, NotificationViewModel } from "../system/admin-panel/Notifications/Model/NotificationViewModel";
import { ObjectGroupViewModel } from "../system/admin-panel/ObjectGroupViewModel";
import { DaysOfWeek } from "./shifts.service";
import { TranslateService } from "@ngx-translate/core";
import { map } from "rxjs/operators";

@Injectable()
export class NotificationsService {

  constructor(private client: HttpClient, private translate: TranslateService) { }

  public GetNotifications() {
    return this.client.get<any>("/ctrl/EventSettings").pipe(map(values => {
      let result = [];
      if (values && values.constructor === Array) {
        for (let item of values) {
          let notification = NotificationViewModel.fromJS(item);
          this.calculateWorkingTime(notification);
          result.push(notification)
        }
      }
      return result;
    }));
  }
  private calculateWorkingTime(notification: NotificationViewModel) {
    let days = [];
    if ((notification.Mask & DaysOfWeek.Monday) == DaysOfWeek.Monday)
      days.push(this.translate.instant("Mn"));
    if ((notification.Mask & DaysOfWeek.Tuesday) == DaysOfWeek.Tuesday)
      days.push(this.translate.instant("Tu"));
    if ((notification.Mask & DaysOfWeek.Wednesday) == DaysOfWeek.Wednesday)
      days.push(this.translate.instant("Wd"));
    if ((notification.Mask & DaysOfWeek.Thursday) == DaysOfWeek.Thursday)
      days.push(this.translate.instant("Th"));
    if ((notification.Mask & DaysOfWeek.Friday) == DaysOfWeek.Friday)
      days.push(this.translate.instant("Fr"));
    if ((notification.Mask & DaysOfWeek.Saturday) == DaysOfWeek.Saturday)
      days.push(this.translate.instant("St"));
    if ((notification.Mask & DaysOfWeek.Sunday) == DaysOfWeek.Sunday)
      days.push(this.translate.instant("Sn"));

    notification.Schedule = days.join() + " " + notification.From + " " + notification.Till;
  }

  public create(model: NotificationViewModel) {
    let reqBody = new CreateNotificationViewModel(model);
    return this.client.post("/ctrl/EventSettings", reqBody);
  }

  public update(model: NotificationViewModel) {
    let reqBody = new CreateNotificationViewModel(model);
    return this.client.put("/ctrl/EventSettings", reqBody);
  }

  public delete(id: number) {
    return this.client.delete("/ctrl/EventSettings/" + id);
  }
  ///////////////////////////////////////////////////////////////////////////
  public GetGroups() {
    return this.client.get<any>("/ctrl/eventsettingsgroups").pipe(map(values => {
      let result = [];
      if (values && values.constructor === Array) {
        for (let item of values)
          result.push(ObjectGroupViewModel.fromJS(item))
      }
      return result;
    }));
  }
  public CreateGroup(input: any) {
    if (input.Id > 0)
      return this.client.put("/ctrl/eventsettingsgroups", input);
    else
      return this.client.post("/ctrl/eventsettingsgroups", input);
  }
  public DeleteGroup(input) {
    return this.client.delete("/ctrl/eventsettingsgroups/" + input.Id);
  }

}
